import styles from "./policy.module.css";

const RefundPolicy = () => {
  return (
    <div className={styles["terms-container"]}>
      <h1>Sekeron Open Mic Refund Policy</h1>

      <p>
        We get it—plans can change last minute. Here’s how our refund policy works:
      </p>

      <ol>
        <li>
          <strong>Full Refund</strong>
          <br />
          Cancel at least 6 hours before the event to get a 100% refund.
        </li>
        <li>
          <strong>Partial Refund</strong>
          <br />
          Cancel between 2 to 6 hours before the event to receive a 50% refund.
        </li>
        <li>
          <strong>No Refund</strong>
          <br />
          Cancel less than 2 hours before the event or miss it entirely—no refund will be issued.
        </li>
        <li>
          <strong>Event Cancellation by Sekeron</strong>
          <br />
          If we cancel or reschedule the event, you’ll receive a full refund or can transfer your spot to a future event.
        </li>
        <li>
          <strong>How to Request a Refund</strong>
          <br />
          Email us at <a href="mailto:support@sekeron.com">support@sekeron.com</a> with your event name, date, and payment details.
        </li>
      </ol>

      <p>
        Refunds will be processed within 5–7 business days to your original payment method.
      </p>
    </div>
  );
};

export default RefundPolicy;
